import { Link, useNavigate } from "react-router-dom";
import { EmailTemplate } from "../../../../models";
import { createTemplate, State, updateTemplate } from "../actions";
import { useActionState, useEffect } from "react";
import FormBody from "../../../../components/form-body";
import Label from "../../../../components/label";
import Input from "../../../../components/input";
import FormError from "../../../../components/form-error";
import Textarea from "../../../../components/textarea";
import { Button } from "../../../../components/button";
import Editor from "../../../../components/editor";

export default function EmailTemplateCreateForm() {
  const navigate = useNavigate();
  const initialState: State = {
    message: null,
    success: false,
    errors: {},
    defaultValues: {
      name: "",
      description:"",
      subject: "",
      body: "",
    },
  };

  
  const [state, formAction, isPending] = useActionState(
    createTemplate,
    initialState
  );
  useEffect(() => {
    if (state.success) {
      navigate("/admin/email-templates");
    }
  }, [state]);

  return (
    <form className="space-y-6 max-w-3xl py-8 text-left" action={formAction}>
      <FormBody>
        <div className="mb-4">
          <Label htmlFor="name">Template Name</Label>
          <Input
            id="name"
            name="name"
            type="text"
            placeholder="Enter feature name"
            aria-describedby="name-error"
            defaultValue={state.defaultValues.name ?? ""}
            required
             
          />
          <FormError id="name-error" message={state.errors?.name} />
        </div>
        <div className="mb-4">
          <Label htmlFor="subject">Subject</Label>
          <Input
            id="subject"
            name="subject"
            required
            aria-describedby="subject-error"
            placeholder="Enter email subject"
            defaultValue={state.defaultValues.subject ?? ""}
          />
          <FormError id="subject-error" message={state.errors?.subject} />
        </div>
        <div className="mb-4">
          <Label htmlFor="description">Description</Label>
          <Textarea
            id="description"
            name="description"
            placeholder="Enter description"
            aria-describedby="description-error"
            defaultValue={state.defaultValues.description ?? ""}
          />
          <FormError
            id="description-error"
            message={state.errors?.description}
          />
        </div>
        <div className="mb-4">
          <Label htmlFor="body">Body</Label>
          <Editor
            name="body"
            defaultValue={state.defaultValues.body ?? ""}
            placeholders={["name", "email", "verification_token","reset_token"]}          />
          <FormError id="body-error" message={state.errors?.body} />
        </div>
      </FormBody>
      <div className="mt-6 flex justify-end gap-4">
        <Link to="/admin/email-templates">
          <Button type="reset" disabled={isPending}>
            Cancel
          </Button>
        </Link>
        <Button
          type="submit"
          disabled={isPending}
          loading={isPending}
          className="min-w-[90px]"
        >
          Save Changes
        </Button>
      </div>
    </form>
  );
}
